import React from 'react';
import SafeIcon from '../common/SafeIcon';

function MetricCard({ icon, label, value, detail, tone = 'teal' }) {
  return (
    <div className={`metric-card tone-${tone}`}>
      <div className="metric-icon">
        <SafeIcon icon={icon} />
      </div>
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        <small>{detail}</small>
      </div>
    </div>
  );
}

export default MetricCard;